import packagesServices from "~/services/packagesServices";
import Constants from "~/helpers/enums/Constants";

const sessionsPackagesAvailable = (businessId, services) => {
    return (
      (dispatch) => {
      if (!businessId || !services || services.length === 0) return;
      packagesServices.activePackageSessions(businessId, services).then((res) => {
          const normalized = (res.data || []).flatMap((serviceGroup) =>
              (serviceGroup.packages || []).flatMap((pkg) =>
                  (pkg.sessions || []).map((session) => ({
                      id: session.bookingId,
                      price: session.price,
                      expiresAt: session.expiresAt,
                      service: {
                          id: serviceGroup.serviceId,
                          name: serviceGroup.serviceName,
                      },
                      professional: {
                          id: pkg.professionalId,
                          name: pkg.professionalName,
                      },
                      bookingTransactionId: pkg.bookingTransactionId,
                      remainingSessions: pkg.remainingSessions,
                      createdAt: pkg.createdAt || null,
                      paymentStatus: pkg.paymentStatus || null,
                      package: pkg.package,
                  }))
              )
          );
          dispatch({
              type: Constants.SET_SESSIONS_PACKAGES_AVAILABLE,
              payload: { sessionsPackagesAvailable: normalized },
          });
      }).catch((err) => {
          console.error("Erro ao buscar sessões de pacote:", err);
      })
  }
    );
}

const sessionsAccepted = (data) => {
    return (dispatch) => {
        dispatch({
            type: Constants.SET_SESSIONS_ACCEPTED,
            payload: { data: data }
        });
    };
}

const clearSessionsAccepted = () => {
    return (dispatch) => {
        dispatch({
            type: Constants.CLEAR_SESSIONS_ACCEPTED,
            payload: { data: [] },
        });
    };
}
export default {
    sessionsPackagesAvailable,
    sessionsAccepted,
    clearSessionsAccepted
}